interface IsValidCoordinatesProps {
  latitude?: number | string | null;
  longitude?: number | string | null;
}

const isNumericCoord = (x: unknown): boolean =>
  (typeof x === 'number' || (typeof x === 'string' && x.trim() !== '')) &&
  Number.isFinite(Number(x));

export const isValidLatitude = (latitude?: number | string | null): boolean => {
  if (!isNumericCoord(latitude)) return false;
  const lat = Number(latitude);
  return lat >= -90 && lat <= 90;
};

export const isValidLongitude = (
  longitude?: number | string | null,
): boolean => {
  if (!isNumericCoord(longitude)) return false;
  const lon = Number(longitude);
  return lon >= -180 && lon <= 180;
};

const isValidCoordinates = (
  coords?: IsValidCoordinatesProps | null,
): boolean => {
  const { latitude, longitude } = coords ?? {};
  return isValidLatitude(latitude) && isValidLongitude(longitude);
};

export default isValidCoordinates;
